import {
  BOOK_A_VIEWING_OPEN,
  BOOK_A_VIEWING_CLOSE,
} from '../../constants';

import { reset } from 'redux-form';

export function bookAViewingOpen(listId) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: BOOK_A_VIEWING_OPEN,
      payload: {
        showBookAViewingModal: true
      }
    });

    return true;
  };
}

export function bookAViewingClose() {

  return async (dispatch, getState, { client }) => {
    dispatch(reset('BookAViewingForm'));
    dispatch({
      type: BOOK_A_VIEWING_CLOSE,
      payload: {
        showBookAViewingModal: false
      }
    });

    return true;
  };
}


// WEBPACK FOOTER //
// src/actions/bookAViewing/bookAViewingModal.js